/**
 * TikTok's in-app browser sandboxes cross-domain navigation, so tapping
 * "Checkout" often fails to land on the Shopify checkout domain unless the
 * shopper manually taps "···" → "Open in Browser". This script detects
 * TikTok's webview and, on checkout tap, hands the navigation off to the
 * OS-level browser (Chrome on Android, Safari on iOS) using URL schemes that
 * the operating system intercepts before TikTok's webview ever sees them.
 * If that hand-off doesn't happen (older TikTok builds sometimes block
 * custom schemes on iOS), a small fallback banner tells the shopper what to
 * tap instead, so they're never stuck without an explanation.
 */
(function tiktokCheckoutBridge() {
  var ua = navigator.userAgent || '';
  var isTikTokInApp = /musical_ly|bytedance|tiktok/i.test(ua);

  if (!isTikTokInApp) return;

  var isAndroid = /Android/i.test(ua);
  var isIOS = /iPhone|iPad|iPod/i.test(ua);

  if (!isAndroid && !isIOS) return;

  function buildBridgeUrl(targetUrl) {
    var bare = targetUrl.replace(/^https?:\/\//, '');
    if (isAndroid) {
      return 'intent://' + bare + '#Intent;scheme=https;package=com.android.chrome;end';
    }
    return 'x-safari-https://' + bare;
  }

  function showFallbackBanner() {
    if (document.querySelector('.tiktok-bridge-banner')) return;

    var banner = document.createElement('div');
    banner.className = 'tiktok-bridge-banner';
    banner.setAttribute('role', 'status');
    banner.innerHTML =
      '<span>For a faster checkout, tap <strong>&#8226;&#8226;&#8226;</strong> above and choose ' +
      '<strong>"Open in Browser"</strong>.</span>' +
      '<button type="button" aria-label="Dismiss">&times;</button>';

    var style = document.createElement('style');
    style.textContent =
      '.tiktok-bridge-banner{position:fixed;left:0;right:0;bottom:0;z-index:9999;' +
      'display:flex;align-items:center;gap:12px;padding:12px 16px;' +
      'background:#111;color:#fff;font-size:14px;line-height:1.4;' +
      'box-shadow:0 -2px 10px rgba(0,0,0,.2);}' +
      '.tiktok-bridge-banner span{flex:1;}' +
      '.tiktok-bridge-banner button{background:none;border:none;color:#fff;' +
      'font-size:20px;line-height:1;padding:0 4px;cursor:pointer;}';

    document.head.appendChild(style);
    document.body.appendChild(banner);

    banner.querySelector('button').addEventListener('click', function () {
      banner.remove();
    });
  }

  function tryBridge(targetUrl) {
    var bridgeUrl = buildBridgeUrl(targetUrl);
    var wasHidden = false;

    function onVisibilityChange() {
      if (document.visibilityState === 'hidden') wasHidden = true;
    }
    document.addEventListener('visibilitychange', onVisibilityChange);

    window.location.href = bridgeUrl;

    setTimeout(function () {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (!wasHidden) showFallbackBanner();
    }, 1200);
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var checkoutButton = target.closest('#checkout, [name="checkout"]');
      if (!checkoutButton) return;

      event.preventDefault();
      tryBridge(window.location.origin + '/checkout');
    },
    true
  );
})();
